import { CareerAdviseVisual } from './CareerAdviseVisual'

export default CareerAdviseVisual
